import script from "./ReservationOptionSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationOptionSection.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationOptionSection.vue?vue&type=style&index=0&id=ebf42726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebf42726"]])

export default __exports__